module.exports = __webpack_public_path__ + "static/media/um.2c7c940e.jpg";